<template>
  <div
    v-loading="loading"
    class="app-main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <div class="section operations">
      <div class="triggers">
        <cargo-button-group-slider>
          <div class="input-label">{{ $t('CargoMsg.Cargo_PortOfLoading') }}</div>
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Airport"
            :show-custom-label-in-option="true"
            :custom-label="airportLabel"
            filterable
            :default-value="filter.pol"
            placeholder=" "
            style="display: inline-block;width: 180px;"
            @parentCallBack="p=>{filter.pol=p.value}"
          />
          <div class="input-label">{{ $t('CargoMsg.Cargo_DestinationPort') }}</div>
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Airport"
            :show-custom-label-in-option="true"
            :custom-label="airportLabel"
            filterable
            :default-value="filter.pod"
            placeholder=" "
            style="display: inline-block;width: 180px;"
            @parentCallBack="p=>{filter.pod=p.value}"
          />
          <div class="input-label" style="color: #666666;">{{ $t('SeaExport.AirlineCompany') }}</div>
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{airCmp:true}"
            filterable
            tag-value="shortName"
            :default-value="filter.carrier"
            placeholder=" "
            style="display: inline-block;width: 200px;"
            @parentCallBack="p=>{filter.carrier=p.value}"
          />
          <el-button type="primary" @click="queryHandler">{{ $t('SeaExport.Query') }}</el-button>
        </cargo-button-group-slider>
        <div style="white-space:nowrap;">
          <el-upload
            :action="URL.price.iataPrice.importIATAFromExcel"
            :headers="{sessionId:$store.getters.userInfo.sessionId}"
            :show-file-list="false"
            accept=".xls"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            style="display: inline-block;"
          >
            <el-button type="primary">{{ $t('CargoMsg.Cargo_Import') }}</el-button>
          </el-upload>
          <el-button type="primary" @click="downloadTemplate">{{ $t('CargoMsg.Cargo_DownLoad_Template') }}</el-button>
          <el-button type="primary" @click="addHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <el-button :disabled="!selectedRow" type="primary" @click="editHandler">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
          <el-button :disabled="!selectedRow" type="primary" @click="delHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
        </div>
      </div>
    </div>
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      class="section"
      @gridReady="params=>{gridApi=params.api}"
    />
    <!-- 新增/编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="priceDialog.visible"
      :title="priceDialog.title"
      :width="$selectByLang('380px', '430px')"
      :close-on-click-modal="false"
      class="price-dialog"
    >
      <el-form :label-width="$selectByLang('65px', '115px')" label-position="left">
        <el-form-item :label="$t('CargoMsg.Cargo_PortOfLoading')" class="content-overflow">
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Airport"
            filterable
            :default-value="priceDialog.form.pol"
            placeholder=" "
            @parentCallBack="p=>{priceDialog.form.pol=p.value}"
          />
          <span>❁</span>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_DestinationPort')" class="content-overflow">
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Airport"
            filterable
            :default-value="priceDialog.form.pod"
            placeholder=" "
            @parentCallBack="p=>{priceDialog.form.pod=p.value}"
          />
          <span>❁</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.AirlineCompany')" class="content-overflow">
          <cargo-cache-advance-select
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{airCmp:true}"
            filterable
            tag-value="shortName"
            :default-value="priceDialog.form.carrier"
            placeholder=" "
            @parentCallBack="p=>{priceDialog.form.carrier=p.value}"
          />
          <span>❁</span>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_CargoType')">
          <el-select v-model="priceDialog.form.cargoType" placeholder=" " filterable allow-create clearable>
            <el-option value="General" />
            <el-option value="Dangerous" />
            <el-option value="Ice" />
            <el-option value="Value" />
            <el-option value="NULL" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_FreightRateM')">
          <cargo-numeric-stepper
            v-model="priceDialog.form.levelM"
            :minimum="0"
            :maximum="99999"
            :value-format-function="formatLevelValue"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_FreightRateN')">
          <cargo-numeric-stepper
            v-model="priceDialog.form.levelN"
            :minimum="0"
            :maximum="99999"
            :value-format-function="formatLevelValue"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_FreightRate45')">
          <cargo-numeric-stepper
            v-model="priceDialog.form.level45"
            :minimum="0"
            :maximum="99999"
            :value-format-function="formatLevelValue"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_FreightRate100')">
          <cargo-numeric-stepper
            v-model="priceDialog.form.level100"
            :minimum="0"
            :maximum="99999"
            :value-format-function="formatLevelValue"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_FreightRate300')">
          <cargo-numeric-stepper
            v-model="priceDialog.form.level300"
            :minimum="0"
            :maximum="99999"
            :value-format-function="formatLevelValue"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_FreightRate500')">
          <cargo-numeric-stepper
            v-model="priceDialog.form.level500"
            :minimum="0"
            :maximum="99999"
            :value-format-function="formatLevelValue"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_FreightRate1000')">
          <cargo-numeric-stepper
            v-model="priceDialog.form.level1000"
            :minimum="0"
            :maximum="99999"
            :value-format-function="formatLevelValue"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
          <el-input v-model="priceDialog.form.remark" type="textarea" :rows="4" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="commitHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button @click="priceDialog.visible=false">{{ $t('Message.Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCacheAdvanceSelect from '@/components/Cargo/Common/cargoCacheAdvanceSelect'
import cargoNumericStepper from '@/components/Cargo/Common/cargoNumericStepper'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { IataPrice } from '@/class/model/sys/IataPrice'
import URL from '@/api/urlTranslator'
import { queryIataPrice, saveIataPrice, deleteIataPrice } from '@/api/price/iataPrice'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'

export default {
  name: 'IATAPrice',
  components: { CargoButtonGroupSlider, cargoAdvanceSelect, cargoCacheAdvanceSelect, cargoNumericStepper },
  data() {
    return {
      loading: false,
      TYPE_NAMES,
      URL,
      filter: {
        pol: '',
        pod: '',
        carrier: ''
      },
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          field: 'pol'
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'pod'
        }, {
          headerName: this.$t('CargoMsg.Cargo_AirlineCompany'),
          field: 'carrier'
        }, {
          headerName: this.$t('CargoMsg.Cargo_CargoType'),
          field: 'cargoType'
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreightRateM'),
          field: 'levelM'
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreightRateN'),
          field: 'levelN'
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreightRate45'),
          field: 'level45'
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreightRate100'),
          field: 'level100'
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreightRate300'),
          field: 'level300'
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreightRate500'),
          field: 'level500'
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreightRate1000'),
          field: 'level1000'
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remark'
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null,
      priceDialog: {
        visible: false,
        title: '',
        form: new IataPrice().fillDefaultValue().getData()
      }
    }
  },
  computed: {
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  methods: {
    airportLabel(item) {
      if (item) {
        return '[' + item.code + ']' + item.englishName
      }
      return ''
    },
    queryHandler() {
      if (!this.filter.pol && !this.filter.pod) {
        this.$message.warning(this.$t('AirExport.PleasePortOfDepartureDestination'))
        return
      }
      this.loading = true
      queryIataPrice(this.filter).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (fileType !== 'xls') {
        this.$message.warning(this.$t('AirExport.SaveFileFormatIsIncorrect'))
      } else {
        return true
      }
    },
    uploadSuccess(response, file, fileList) {
      if (response.code === '0') {
        const data = response.data
        if (data.success) {
          this.$message.success(this.$t('AirExport.SuccessfullyImported') + data.insert + this.$t('AirExport.PiecesOfData'))
        } else if (data.detail === 'EXCEL FILE ERROR') {
          this.$message.warning(this.$t('AirExport.SaveFileFormatIsIncorrect'))
        } else if (data.detail === 'FILE STREAM ERROR') {
          this.$message.warning(this.$t('AirExport.SaveFailed'))
        }
      } else {
        this.$message.error(response.message)
      }
    },
    addHandler() {
      this.priceDialog.title = this.$t('CargoMsg.Cargo_NewIATAFreightRate')
      this.priceDialog.form = new IataPrice().fillDefaultValue().getData()
      this.toLevelFixedTwo()
      this.priceDialog.visible = true
    },
    editHandler() {
      this.priceDialog.title = this.$t('CargoMsg.Cargo_EditIATAFreightRate')
      this.priceDialog.form = { ...this.selectedRow }
      this.toLevelFixedTwo()
      this.priceDialog.visible = true
    },
    toLevelFixedTwo() {
      const form = this.priceDialog.form
      form.levelM = Number(form.levelM.toFixed(2))
      form.levelN = Number(form.levelN.toFixed(2))
      form.level45 = Number(form.level45.toFixed(2))
      form.level100 = Number(form.level100.toFixed(2))
      form.level300 = Number(form.level300.toFixed(2))
      form.level500 = Number(form.level500.toFixed(2))
      form.level1000 = Number(form.level1000.toFixed(2))
    },
    formatLevelValue(value) {
      if (value === 0) {
        return ''
      }
      return value.toFixed(2)
    },
    commitHandler() {
      const form = this.priceDialog.form
      if (!form.pol) {
        this.$message.warning(this.$t('AirExport.PleaseThePortOfDeparture'))
        return
      }
      if (!form.pod) {
        this.$message.warning(this.$t('AirExport.PleaseEnterTheDestinationPort'))
        return
      }
      this.loading = true
      saveIataPrice(form).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.priceDialog.visible = false
        if (form.uuid) {
          Object.assign(this.selectedRow, res.data)
          this.gridApi.refreshCells({ force: true })
        } else {
          this.rowData.push(res.data)
          if (this.selectedRow) {
            const selectedKey = this.selectedRow.uuid
            setTimeout(() => {
              const nodes = this.gridApi.rowModel.rowsToDisplay
              const targetNode = nodes.find(p => p.data.uuid === selectedKey)
              this.gridApi.setFocusedCell(targetNode.rowIndex, this.gridApi.columnController.getAllDisplayedColumns()[0])
            }, 100)
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    delHandler() {
      this.$confirm(this.$t('AirExport.AreYouWantToDelete'), this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = true
        deleteIataPrice({ uuid: this.selectedRow.uuid }).then(res => {
          const index = this.rowData.findIndex(p => p.uuid === this.selectedRow.uuid)
          if (index >= 0) {
            this.rowData.splice(index, 1)
          }
        }).finally(() => {
          this.loading = false
        })
      }).catch()
    },
    // 下载模板
    downloadTemplate() {
      ExportUtils.downloadTemplateFile('IATA运价导入模板.xls', 'booking')
    }
  }
}
</script>

<style scoped lang="scss">
#app .app-main-content ::v-deep {
  .el-loading-mask {
    z-index: 999999;
  }
}
.input-label {
  display: inline-block;
  padding: 0 5px;
  color: blue;
}
.price-dialog ::v-deep {
  .el-form-item__content {
    width: 230px;
    .el-input-number {
      width: 100%;
    }
  }
  .content-overflow {
    .el-form-item__content {
      display: flex;
      width: auto;
      div:first-child {
        width: 230px;
      }
    }
  }
}
</style>
